import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-4">
              ISN Rénovation & Construction
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {companyInfo.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">
              Navigation
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/realisations" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Réalisations
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-600 text-sm">
                <Phone size={16} className="mr-2" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-gray-900 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center text-gray-600 text-sm">
                <Mail size={16} className="mr-2" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-gray-900 transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} ISN Rénovation & Construction. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};